module.exports = __webpack_public_path__ + "static/img/color2-2.42d066c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/color2-2.jpg
// module id = aljb
// module chunks = 1